import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enStrings from '../../../../locales/en.json';
import esStrings from '../../../../locales/es.json';
import itStrings from '../../../../locales/it.json';

i18next
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        detection: { order: ['navigator'] },
        fallbackLng: 'en',
        nonExplicitSupportedLngs: true,
        supportedLngs: ['en', 'es', 'it'],
        resources: {
            en: {
                translation: enStrings
            },
            es: {
                translation: esStrings
            },
            it: {
                translation: itStrings
            }
        }
    });
